import Vue, { createApp, h } from "vue";
import Cookies from "js-cookie";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// import Vuelidate from "vuelidate";
import AppLoader from "@/components/global/AppLoader";
import AppEmptyState from "@/components/global/AppEmptyState";
import AppBreadCrumb from "@/components/global/AppBreadCrumb";
import AppStatus from "@/components/global/AppStatus";
import LoadingButton from "@/components/global/LoadingButton";
import Checkbox from "@/components/global/checkbox";
import FileUpload from "@/components/global/file-upload";
import FormError from "@/components/global/formError/index.vue";
import CustomTags from "@/components/CustomTags.vue";
// permission control
// import "@/permission";
// Global Mixin
import "./mixin/global";
// Global Filter
import "./filter/global";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";


// Main Style
import "./styles/main.scss";
import "./styles/index.scss";
// Define default global options here (optional)

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
// Vue.use(Vuelidate);

// Global Components
Vue.component("AppLoader", AppLoader);
Vue.component("AppEmptyState", AppEmptyState);
Vue.component("AppBreadCrumb", AppBreadCrumb);
Vue.component("AppStatus", AppStatus);
// Vue.component("v-select", vSelect);
Vue.component("Checkbox", Checkbox);
Vue.component("FileUpload", FileUpload);
Vue.component("FormError", FormError);
Vue.component("CustomTags", CustomTags);
Vue.component("LoadingButton", LoadingButton);
export const app = createApp({
  // vuetify,
  render: () => h(App),
})
  .use(router)
  .use(store)
  .mount("#app");
